module.exports = __webpack_public_path__ + "img/two1Orange.ef82be06.jpg";